import PropTypes from 'prop-types';
import { useFormContext } from './context';
export const getEmptyFieldValue = type => {
  switch (type || 'text') {
    default:
      return '';
  }
};
const {
  ControlGroup,
  Inputv2
} = svs.ui.reactForm;
const FormFieldInput = ({
  autoComplete,
  id,
  isDisabled,
  title,
  type = 'text',
  pattern,
  placeholder
}) => {
  const {
    formData,
    updateField,
    formErrors
  } = useFormContext();
  const value = formData[id] ?? '';
  const formatSSN = val => {
    const digits = val.replace(/\D/g, '').slice(0, 10);
    if (digits.length <= 6) {
      return digits;
    }
    return `${digits.slice(0, 6)}-${digits.slice(6)}`;
  };
  const formatOrgNumber = val => {
    const digits = val.replace(/\D/g, '').slice(0, 10);
    return digits.length <= 6 ? digits : `${digits.slice(0, 6)}-${digits.slice(6)}`;
  };
  const handleChange = e => {
    let newValue = e.target.value;
    const titleLower = title.toLowerCase();
    if (id === 'signatorySsn' || titleLower.includes('personnummer')) {
      newValue = formatSSN(newValue);
    } else if (pattern && pattern.includes('\\d{6}') || titleLower.includes('organisationsnummer')) {
      newValue = formatOrgNumber(newValue);
    }
    updateField(id, newValue);
  };
  return <ControlGroup errorMessage={formErrors[id]} hasError={Boolean(formErrors[id])} v2>
      <label className="block text-sm font-medium mb-1 text-gray-700" htmlFor={id}>
        {title}
      </label>
      <Inputv2 autoComplete={autoComplete || 'off'} disabled={isDisabled} id={id} onChange={handleChange} pattern={pattern} placeholder={placeholder} type={type} value={value} />

    </ControlGroup>;
};
FormFieldInput.propTypes = {
  autoComplete: PropTypes.string,
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  pattern: PropTypes.string,
  placeholder: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.string
};
export default FormFieldInput;